module.exports = __webpack_public_path__ + "assets/img/is-favorite-neutral.76e33f9e.svg";